import { IncomeConfirmationModalTexts } from '../IncomeConfirmationModal.texts';

export const getRegularApplicationBenefits = (bankName: string) => [
  `${IncomeConfirmationModalTexts.regularOnlyBankBenefit} ${bankName}`,
  IncomeConfirmationModalTexts.regularBenefitTermsMayChange,
  IncomeConfirmationModalTexts.regularBenefitManagerWillCall,
  IncomeConfirmationModalTexts.regularBenefitOfficeVisit,
];
